import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		count: 2,
		tabbarKeepAlive: [
			// tabbar页面总是在页面缓存中
			'login',
			'shoppingCart',
			'calendar',
			'vuejswar'
		],
		tempKeepAlive: [], // 临时加入缓存的页面
		tabbarList: [
			{
				name: '首页',
				icon: 'home-o',
				path: '/'
			},
			{
				name: '工具',
				icon: 'search',
				path: '/shoppingCart'
			},
			{
				name: '我的',
				icon: 'setting-o',
				path: '/calendar'
			},
			{
				name: '实战',
				icon: 'setting-o',
				path: '/vuejswar'
			}
		]
	},
	mutations: {
		add(state) {
			state.count++
		},
		reduce(state) {
			state.count--
		},
		handleTempKeepAlive(state, { toName, fromName }) {
			// 处理临时加入缓存的页面
			if (state.tempKeepAlive.includes(toName)) {
				// A->B->C,C返回之前的页面B，清除C
				state.tempKeepAlive.includes(fromName) &&
					state.tempKeepAlive.splice(state.tempKeepAlive.indexOf(fromName), 1)
			} else {
				// 进入新页面，添加它
				state.tempKeepAlive.push(toName)
			}
		},
		clearTempKeepAlive(state) {
			// 清空临时加入缓存的页面
			state.tempKeepAlive = []
		}
	},
	getters: {
		keepAlive(state) {
			// 所有缓存的页面
			return state.tabbarKeepAlive.concat(state.tempKeepAlive)
		}
	}
})

export default store
